import api from "@/router/api";
import { getLocalDateTime } from "@/utils/FormatarEntradas";

export default {
  async getAtividadesParticipante(page, size, usuarioId, retornarNumPag) {
    const response = await api.get("/participantes-atividades", {
      params: {
        page,
        size,
        usuarioId,
      },
    });

    if (retornarNumPag) {
      return {
        numPag: response.data?.totalPages ?? 1,
        atividades: response.data?.content ?? response.data ?? [],
      };
    }
    return response.data?.content ?? response.data ?? [];
  },

  async getParticipantesAtividade(
    page,
    size,
    atividadeId,
    apenasConfirmados = false
  ) {
    const params = { page, size };
    if (apenasConfirmados) {
      params.apenasConfirmados = true;
    }
    const response = await api.get(`/participantes-atividades/${atividadeId}`, {
      params,
    });
    return response.data?.content ?? response.data ?? [];
  },

  async postParticipanteAtividade(param1, param2) {
    const atividadeId = param2 ? param2 : param1;
    const dataSolicitacao = getLocalDateTime(new Date(), "ISO");
    const response = await api.post(
      `/participantes-atividades/${atividadeId}`,
      {
        dataSolicitacao,
      }
    );
    return response.data;
  },

  async removerInscricao(participanteId) {
    const response = await api.delete("/participantes-atividades", {
      params: { participanteId },
    });
    return response.data;
  },

  async cancelarInscrição(participanteId) {
    return await this.removerInscricao(participanteId);
  },

  async desinscreverUsuario(atividadeId, user) {
    let participanteId = null;
    const userId = user?.userId || user?.id;

    if (userId) {
      try {
        const participacoes = await this.getAtividadesParticipante(
          0,
          100,
          userId
        );
        const lista = Array.isArray(participacoes)
          ? participacoes
          : participacoes?.content || participacoes?.atividades || [];
        const match = lista.find(
          (p) =>
            p.atividade?.id === atividadeId ||
            p.atividade?.atividadeId === atividadeId ||
            p.atividadeId === atividadeId ||
            p.idAtividade === atividadeId
        );
        if (match?.participanteId) {
          participanteId = match.participanteId;
        }
      } catch (e) {
        console.warn("Erro ao buscar participações do usuário:", e);
      }
    }

    if (!participanteId && atividadeId) {
      try {
        const inscritos = await this.getParticipantesAtividade(
          0,
          100,
          atividadeId
        );
        const listaInscritos = Array.isArray(inscritos)
          ? inscritos
          : inscritos?.content || [];
        const matchUser = listaInscritos.find(
          (p) =>
            (user?.email &&
              p.email?.toLowerCase() === user.email?.toLowerCase()) ||
            (user?.cpf && p.cpf === user.cpf) ||
            (user?.nome &&
              p.nome?.toLowerCase() === user.nome?.toLowerCase()) ||
            (userId && (p.usuarioId === userId || p.id === userId))
        );
        if (matchUser?.participanteId) {
          participanteId = matchUser.participanteId;
        }
      } catch (e) {
        console.warn("Erro ao buscar inscritos da atividade:", e);
      }
    }

    const idFinal = participanteId || userId;
    if (!idFinal) {
      throw new Error("Identificador do participante não encontrado.");
    }

    return await this.removerInscricao(idFinal);
  },

  async isUsuarioLogadoInscrito(atividadeId) {
    const response = await api.get(
      `/participantes-atividades/inscrito/${atividadeId}`
    );
    return response.data;
  },

  async getInscritosByAtividade(atividadeId) {
    const response = await api.get(`atividade/inscritos/${atividadeId}`);
    return response.data;
  },
};
